import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单寄出',
  path: 'SendTheReceipt'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'SendTheReceipt',
    component: () => import(/* webpackChunkName: "SendTheReceipt" */ '@/views/receiptManagement/sendTheReceipt/index.vue'),
    meta: {
      title: '回单寄出'
    }
  }
]
